import Home from "../view/Home";
import Service from '../view/Service';
import Contact from "../view/Contact";

const routes = [
    { path: '/', component: Home , label:"Home"},
    { path: '/services', component: Service, label: "Service" },
    { path: '/contact', component: Contact, label: "contact" },
  ];
  export default routes;